import { DashboardUserType } from '@/utils/enums';
import { Box } from '@mui/material';
import { LoginSellerProps } from '.';

export function LoginArt({ loginType }: LoginSellerProps) {
  return (
    <Box
      sx={{
        width: '50%',
        height: '100%',
        padding: '8px',
        position: 'relative',
        background:
          loginType === DashboardUserType.ADMIN
            ? 'rgb(218, 225, 243)'
            : undefined,
      }}
    >
      {loginType === DashboardUserType.SELLER && (
        <img
          src="/assets/login-art.png"
          alt="login-art"
          width="100%"
          height="100%"
          style={{
            objectFit: 'contain',
          }}
        />
      )}
      {loginType === DashboardUserType.ADMIN && (
        <img
          src="https://static.mercanto.mx/assets/internal-admin/laptop-with-credit-card-payment.webp"
          alt="laptop-with-credit-card-payment"
          style={{
            width: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          loading="lazy"
        />
      )}
    </Box>
  );
}
